export class DataSource {
    Subject: string;
    StartTime: Date;
    EndTime: Date;
    TempId: string;
    NMesa: string;
    Ubicacion: string;
}
